export default {
    badge: 'Distintivo',
    close: 'Fechar',
    dataIterator: {
        noResultsText: 'Nenhum registro correspondente encontrado',
        loadingText: 'Carregando itens...'
    },
    dataTable: {
        itemsPerPageText: 'Linhas por página:',
        ariaLabel: {
            sortDescending: ': Ordenado de forma decrescente. Ative para remover a ordenação.',
            sortAscending: ': Ordenado de forma crescente. Ative para ordenar de forma decrescente.',
            sortNone: ': Não ordenado. Ative para ordenar de forma crescente.'
        },
        sortBy: 'Ordenar por'
    },
    dataFooter: {
        itemsPerPageText: 'Itens por página:',
        itemsPerPageAll: 'Todos',
        nextPage: 'Próxima página',
        prevPage: 'Página anterior',
        firstPage: 'Primeira página',
        lastPage: 'Última página',
        pageText: '{0}-{1} de {2}'
    },
    datePicker: {
        itemsSelected: '{0} selecionado(s)'
    },
    noDataText: 'Nenhum dado disponível',
    carousel: {
        prev: 'Visual anterior',
        next: 'Próximo visual',
        ariaLabel: {
            delimiter: 'Slide do carrossel {0} de {1}'
        }
    },
    calendar: {
        moreEvents: '{0} mais'
    },
    fileInput: {
        counter: '{0} arquivos',
        counterSize: '{0} arquivos ({1} no total)'
    },
    timePicker: {
        am: 'AM',
        pm: 'PM'
    }
}
